import React, { useEffect, useRef, useState } from 'react';
import { apiPaths, get } from '../../platform-components/api-integration-util';
import { getMultiLineString } from '../../platform-components/utils/common-utils';
import { getSelectedExamInfo } from '../../platform-components/utils/configuration';
import {
  getUserDetails,
  getUserExamDetails,
  setUserExamDetails,
} from '../../platform-components/utils/shared-data.service';

export const TakeExam = () => {
  let [questionDetails, setQuestion] = useState({});
  let [id, setId] = useState(null);
  let [loading, updateLoading] = useState(true);
  let [displyNavs, setDisplayNavs] = useState(false);
  let [disablePrev, setDisablePrev] = useState(false);
  let [disableNext, setDisableNext] = useState(false);
  let [questionIds, setQuestionIds] = useState([]);
  let time = useRef();
  let [updateTime, setUpdatedTime] = useState(60);

  const [seconds, setSeconds] = useState(60);
  const [isActive, setIsActive] = useState(false);
  function toggle() {
    setIsActive(!isActive);
  }

  function reset() {
    setSeconds(0);
    setIsActive(false);
  }
  useEffect(() => {
    let interval = null;
    let userExamDetilsObj = {
      userId: 0,
      tenantId: 0,
      examId: 0,
      questionId: 0,
      selectedAnswer: 0,
      isCorrect: 0,
      isAttempted: 0,
      createdDate: '',
      createdBy: '',
      updatedDate: '',
      updatedBy: '',
    };
    if (isActive) {
      interval = setInterval(() => {
        if (seconds == 0) {
          toggle();
        } else {
          setSeconds((seconds) => seconds - 1);
        }
      }, 60000);
    } else if (!isActive) {
      // && seconds !== 0
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);
  const onNavClick = (button, initial) => {
    let ids = questionIds;
    let index = ids.indexOf(+id);

    if (!initial) {
      if (button === 'prev') {
        index--;
      } else {
        index++;
      }
    }
    if (index == 0) {
      if (!disablePrev) setDisablePrev(true);
    } else {
      if (disablePrev) setDisablePrev(false);
    }
    if (index === ids.length - 1) {
      if (!disableNext) setDisableNext(true);
    } else {
      if (disableNext) setDisableNext(false);
    }
    // props.history.push('/app/question/' + ids[index + 1]);
    if (!initial) setId(ids[index]);
  };
  const getQuestionDetails = (questionId) => {
    get(apiPaths.questionbyid, { id: questionId }).then(({ result }) => {
      setQuestion(result);
    });
  };
  useEffect(() => {
    if (typeof id === 'number') getQuestionDetails(id);
    if (questionIds.length > 1) {
      onNavClick('p', true);
      setDisplayNavs(true);
    }
  }, [id]);

  useEffect(() => {
    get(apiPaths.questionsListByExam + '/' + getSelectedExamInfo()?.examId, {
      tenantId: getUserDetails()?.tenantId,
    }).then((val) => {
      let ids = val?.result?.map((ele) => ele?.examQuestionId?.questionId);
      setUserExamDetails(
        val?.result?.reduce((acc, ele) => {
          acc[ele.examQuestionId.questionId] = {
            userId: getUserDetails().userId,
            tenantId: getUserDetails().tenantId,
            examId: ele.examQuestionId.examId,
            questionId: ele.examQuestionId.questionId,
            selectedAnswer: null,
            isCorrect: null,
            isAttempted: 0,
            createdDate: new Date(),
            createdBy: '',
            updatedDate: '',
            updatedBy: '',
          };
          return acc;
        }, {})
      );
      setQuestionIds(ids);
      setId(ids[0]);
      toggle();
    });
  }, []);
  const onAnswerSelection = (answerId) => {
    let ued = getUserExamDetails();
    ued[id].isAttempted = true;
    let correctObj = questionDetails?.answers.find((ele) => ele.correct);
    if (correctObj?.answerId == answerId) {
      ued[id].isCorrect = true;
    } else {
      ued[id].isCorrect = false;
    }
    ued[id].selectedAnswer = answerId;

    setUserExamDetails(ued);
  };
  // useEffect(() => {
  //   if (typeof time?.current?.count !== 'number' || time?.current.count <= 0) {
  //     return;
  //   }
  //   const id = setInterval(() => {
  //     time.current['count'] = time.current.count--;
  //     console.log('hi', time?.current.count);
  //   }, 10000);
  //   // return () => clearInterval(id);
  // }, [time]);

  return (
    <React.Fragment>
      <div class='main-heading'>
        <span>{getSelectedExamInfo()?.examName}</span>
        <span style={{ padding: '0 20px' }}>
          {questionIds.map((ele, index) => {
            return (
              <span
                key={index}
                style={{
                  padding: ' 0 10px',
                  background: 'white',
                  cursor: 'pointer',
                  borderRadius: '22px',
                }}
                onClick={() => {
                  if (id != ele) {
                    setId(ele);
                  }
                }}
              >
                {+index + 1}
              </span>
            );
          })}
        </span>
        <span style={{ float: 'right', marginRight: '10px' }}>
          <span style={{ paddingRight: '10px' }}>
            Time Left:{seconds}
            {/* ./time?.current?.count} */}
          </span>
          {questionIds.indexOf(+id) + 1 + ' / ' + questionIds.length}
          <button class='btn-common'>End Exam</button>
        </span>
      </div>

      <div className='form-elements'>
        <label>question</label>
        <textarea
          className='form-details'
          name='question'
          value={getMultiLineString(questionDetails?.question)}
          readOnly={true}
        ></textarea>
      </div>
      <div className='form-sub-div form-sub-div-nomargin'>
        {questionDetails?.answers?.map((ele, ind) => {
          return (
            <span key={ele?.answerId} className='option-sub'>
              {getUserExamDetails()[id].selectedAnswer}
              {ele?.answerId}
              <label className='form-label-option'>{ind + 1})</label>
              <span className='form-elements'>
                <input
                  style={{ width: '10px' }}
                  type='radio'
                  name={'option'}
                  readOnly
                  onChange={() => {
                    onAnswerSelection(ele?.answerId);
                  }}
                  selected={
                    getUserExamDetails()[id].selectedAnswer == ele?.answerId
                  }
                ></input>
                <label className='form-label-option'> {ele?.answer}</label>
              </span>
            </span>
          );
        })}
      </div>
      <div className='btn-list-div'>
        {displyNavs ? (
          <React.Fragment>
            <button
              className='btn-common'
              onClick={() => onNavClick('prev')}
              disabled={disablePrev}
            >
              Previous
            </button>
            <button
              className='btn-common'
              disabled={disableNext}
              onClick={() => onNavClick('next')}
            >
              Next
            </button>
          </React.Fragment>
        ) : (
          ''
        )}
      </div>
    </React.Fragment>
  );
};
